
class wifiApi {
  constructor () {
    if (!window.wkb) {
      window.wkb = {}
    }
  }

  hasReaderSDK () {
    return new Promise((resolve, reject) => {
      window.wkb.call('getTaichiStringValue', {
        key: 'V1_LSKEY_86981',
        defaultValue: 'V1_LSKEY_86981',
        success: (res) => {
          console.log('getTaichiStringValue', res)
          if (res == 'B') {
            resolve(true)
          } else {
            resolve(false)
          }
        },
        error: (res) => {
          resolve(false)
        }
      })
    })
  }

  isWifiBrowser () {
    if (window.wkb.isWKBrowser === '') {
      console.log('非钥匙浏览器')
      return false
    } else if (window.wkb.isWKBrowser === 'android') {
      console.log('android端钥匙浏览器')
      return true
    } else if (window.wkb.isWKBrowser === 'ios') {
      console.log('ios端钥匙浏览器')
      return true
    }
  }

  IsAppInstalled (packageName) {
    return new Promise((resolve, reject) => {
      window.wkb.call('isAppInstalled', {
        packageName: packageName,
        success: (res) => {
          console.log('isAppInstalled', res)
          if (res) {
            resolve(true)
          } else {
            resolve(false)
          }
        },
        error: (res) => {
          resolve(false)
        }
      })
    })
  }

  getAppInfoAll () {
    return new Promise((resolve) => {
      window.wkb.call('getAppInfo', {
        success: (res) => {
          resolve(res)
        },
        error: () => {
          resolve({})
        }
      })
    })
  }

  openApp (packageName, appHid = '') {
    window.wkb.call('openApp', {
      packageName: packageName,
      appHid: appHid
    })
  }
}


export default new wifiApi()


// WEBPACK FOOTER //
// ./src/common/js/wifiApi.js